import React, { createContext, useContext, useReducer, useEffect } from "react";

const CartContext = createContext(null);

const STORAGE_KEY = "ikone_cart";

function cartReducer(state, action) {
  switch (action.type) {
    case "ADD": {
      const existing = state.find((i) => i.slug === action.item.slug);
      if (existing) {
        return state.map((i) =>
          i.slug === action.item.slug
            ? { ...i, kolicina: i.kolicina + action.qty }
            : i
        );
      }
      return [...state, { ...action.item, kolicina: action.qty }];
    }
    case "REMOVE":
      return state.filter((i) => i.slug !== action.slug);
    case "UPDATE_QTY":
      return state
        .map((i) => i.slug === action.slug ? { ...i, kolicina: action.qty } : i)
        .filter((i) => i.kolicina > 0);
    case "CLEAR":
      return [];
    case "LOAD":
      return action.items;
    default:
      return state;
  }
}

export function CartProvider({ children }) {
  const saved = (() => {
    try { return JSON.parse(localStorage.getItem(STORAGE_KEY)) || []; }
    catch { return []; }
  })();

  const [items, dispatch] = useReducer(cartReducer, saved);

  useEffect(() => {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
  }, [items]);

  const addToCart = (item, qty = 1) => dispatch({ type: "ADD", item, qty });
  const removeFromCart = (slug) => dispatch({ type: "REMOVE", slug });
  const updateQty = (slug, qty) => dispatch({ type: "UPDATE_QTY", slug, qty });
  const clearCart = () => dispatch({ type: "CLEAR" });

  const totalItems = items.reduce((sum, i) => sum + i.kolicina, 0);
  const totalPrice = items.reduce((sum, i) => {
    const num = parseFloat(i.cena.replace(/[^\d,]/g, "").replace(",", ".")) || 0;
    return sum + num * i.kolicina;
  }, 0);

  return (
    <CartContext.Provider value={{ items, addToCart, removeFromCart, updateQty, clearCart, totalItems, totalPrice }}>
      {children}
    </CartContext.Provider>
  );
}

export const useCart = () => useContext(CartContext);
